import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import firebase from "firebase/app";
import "firebase/database";

export default (action$) =>
  action$.ofType(Types.BACK_TO_QUEUE).mergeMap((action) => {
    const lanePath = `ranges/${action.location}/${action.range}/lane-${action.laneNumber}`;

    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref(lanePath)
        .once("value")
        .then((snapshot) => {
          const lane = snapshot.val();
          const queuePath = `queues/${action.location}`;
          const savePromise = firebase
            .database()
            .ref(queuePath)
            .push(lane.assignment);
          const updatePromise = firebase.database().ref(lanePath).update({
            status: "open",
            assignment: null,
          });

          Promise.all([savePromise, updatePromise])
            .then(() => resolve(Creators.completeEditLane()))
            .catch(() => reject(Creators.completeEditLane()));
        })
        .catch(() => reject(Creators.completeEditLane()));
    });
  });



// WEBPACK FOOTER //
// ./src/staff/epics/backToQueue.js